
import { defineComponent, PropType, ref, computed, watch, nextTick } from 'vue'
import ValidationInput from '../inputs/ValidationInput.vue'
import phoneValidator, { isValidPhone } from '../../helpers/validators/phoneValidator'
import debounce from 'lodash/debounce';

export default defineComponent({
    components: { ValidationInput },
    props: {
        value: { type: Array as PropType<string[]>, default: () => [] },
        placeholder: { type: String },
        canDeleteFirstItem: { type: Boolean, default: false },
        onInputChangeTransform: {
            type: Function as PropType<(v: string) => string>,
        },
        color: { type: String },
        validator: { type: Function },
    },
    setup(props, { emit }) {        
        const localValue = ref<string[]>([])
        const inputs = ref<any[]>([])
        const itemKeys = ref<string[]>([])
        
        const updateKeys = (removedIndex: number | null = null) => {
            if (removedIndex !== null) {
                itemKeys.value.splice(removedIndex, 1)
            } else {
                itemKeys.value = localValue.value.map((_, index) => 
                    itemKeys.value[index] || `phone-${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${index}`
                )
            }
        }

        watch(() => props.value, (newValue) => {
            const normalizedValue = Array.isArray(newValue) ? newValue : []
            if (JSON.stringify(localValue.value) !== JSON.stringify(normalizedValue)) {
                localValue.value = [...normalizedValue]
                updateKeys()
            }
        }, { immediate: true, deep: true })

        const updateItem = debounce((index: number, value: string) => {
            localValue.value[index] = value
            emit('input', [...localValue.value])
        }, 300, { leading: false, trailing: true })

        const removeItem = (index: number) => {
            localValue.value.splice(index, 1)
            updateKeys(index)
            emit('input', [...localValue.value])
        }

        const addItem = () => {
            localValue.value.push('')
            updateKeys()
            emit('input', [...localValue.value])
            
            nextTick(() => {
                const newIndex = localValue.value.length - 1
                if (inputs.value[newIndex]) {
                    const inputEl = inputs.value[newIndex].$el?.querySelector('input')
                    inputEl?.focus()
                }
            })
        }

        const canAddItem = computed(() => {
            return props.value.every(item => isValidPhone(item))
        })

        return { 
            localValue,
            inputs,
            itemKeys,
            updateItem, 
            removeItem, 
            addItem, 
            phoneValidator, 
            canAddItem
        }
    },
})
